"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EspoolPropertiesCompact = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * espool properties that are used by the individual applications compact requests.
 */
class EspoolPropertiesCompact {
}
exports.EspoolPropertiesCompact = EspoolPropertiesCompact;
_a = echain_shared_igus_fundamentals_1.AppName.EIQ, _b = echain_shared_igus_fundamentals_1.AppName.EKE, _c = echain_shared_igus_fundamentals_1.AppName.EIC, _d = echain_shared_igus_fundamentals_1.AppName.ECF;
EspoolPropertiesCompact[_a] = ['Id', 'EchainId', 'ArtNr', 'SerieKuerzel'];
EspoolPropertiesCompact[_b] = EspoolPropertiesCompact[echain_shared_igus_fundamentals_1.AppName.EIQ];
EspoolPropertiesCompact[_c] = EspoolPropertiesCompact[echain_shared_igus_fundamentals_1.AppName.EIQ];
EspoolPropertiesCompact[_d] = ['EchainId'];
//# sourceMappingURL=EspoolPropertiesCompact.js.map